export const HOURS_PER_DAY = 24;
export const SECONDS_PER_HOUR = 3600;
export const MILLISECONDS_PER_SECOND = 1000;
export const CZECH_HOLIDAYS = [
  "1.1",
  "1.5",
  "8.5",
  "5.7",
  "6.7",
  "28.9",
  "28.10",
  "17.11",
  "24.12",
  "25.12",
  "26.12",
];
